import moment from 'moment';
import { Row } from 'antd';
import React from 'react';

import {
  AssignmentHistoryTerminationViewModel,
  HistoryResponseModel,
} from 'api/adminApiClient';
import { getTerminationAssignmentLabel } from 'utils/assignmentUtils';
import HistoryField from '../HistoryField';
import HistoryLog from '../HistoryLog';
import { downloadFile } from 'utils/fileUtils';
import BaseAlert from 'components/wrappers/BaseAlert/BaseAlert';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { getAssignmentTerminationAttachmentFile } from 'redux/reducers/assignmentSlice';

type Props = {
  historyItem: HistoryResponseModel;
};

export default function AssignmentTerminationDetailsInfo(props: Props) {
  const { historyItem } = props;
  const historyId = historyItem.id || '';
  const sectionName = 'termination-info';
  const dispatch = useAppDispatch();

  const terminationInfo =
    historyItem.details as AssignmentHistoryTerminationViewModel;
  const attachments = terminationInfo.attachments || [];

  const handleAssignmentTerminationDownload = async (
    fileKey?: string,
    fileName?: string,
  ) => {
    const result = await dispatch(
      getAssignmentTerminationAttachmentFile({ fileKey, fileName }),
    );

    if (getAssignmentTerminationAttachmentFile.fulfilled.match(result)) {
      try {
        await downloadFile({
          downloadUrl: result.payload.downloadUrl,
          fileName: result.payload.fileName,
        });
      } catch (e: any) {
        BaseAlert.error(e.message);
      }
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  const renderTerminationDetails = (
    terminationInfo: AssignmentHistoryTerminationViewModel,
  ) => (
    <Row gutter={[10, 10]}>
      <HistoryField
        title="Last working day"
        value={moment(terminationInfo.terminationDate).format('MM/DD/YYYY')}
        dataId={`${sectionName}-last-working-day-field`}
      />

      <HistoryField
        title="Termination reason"
        value={getTerminationAssignmentLabel(terminationInfo.terminationReason)}
        dataId={`${sectionName}-reason-field`}
      />

      <HistoryField
        title="Eligible for rehire"
        value={terminationInfo.eligibleForRehire ? 'Yes' : 'No'}
        dataId={`${sectionName}-eligible-for-rehire-field`}
      />

      <HistoryField
        title="Additional info"
        value={terminationInfo.details}
        dataId={`${sectionName}-additional-info-field`}
      />

      <HistoryField
        title="Supporting documents"
        emptyText="No files"
        value={
          attachments.length > 0
            ? attachments.map((file) => (
                <div
                  className="link-imitation"
                  key={file.fileKey}
                  onClick={() =>
                    handleAssignmentTerminationDownload(
                      file.fileKey,
                      file.fileName,
                    )
                  }
                >
                  {file?.fileName}
                </div>
              ))
            : null
        }
        dataId={`${sectionName}-supporting-documents-field`}
      />
    </Row>
  );

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderTerminationDetails(terminationInfo)}
    />
  );
}
